var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent
